import template from './lendersList.template.html';

export default {
  template,
  bindings: {
    lenders: '<',
    documents: '<',
    expectedRate: '<',
    isInvestment: '<',
    isQuickTool: '<',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listServiceNew, lendersService) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.CurrentCurrency = $rootScope.CurrentCurrency();
      ctrl.natural = $rootScope.natural;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      ctrl.initialize = () => {
        ctrl.lenders = ctrl.lenders || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.expectedRate = ctrl.expectedRate || 0;
        ctrl.isInvestment = ctrl.isInvestment || false;
        ctrl.isQuickTool = ctrl.isQuickTool || false;
        ctrl.list.setData(ctrl.lenders);
        ctrl.list.setOrderBy('getMaximumBorrowing()');
        ctrl.list.setOrderBy('getMaximumBorrowing()');
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.downloadCalculator = ($event, doc) => {
        $event.stopPropagation();
        lendersService.getCalculator(doc);
      };

      ctrl.getLenderDocument = (idLender, isLogo) => {
        if (idLender) {
          const doc = _.find(
            ctrl.documents || [],
            (d) =>
              d?.lender[0]?.id === idLender &&
              _.indexOf(d?.type, isLogo ? 'LOGO' : 'CALCULATOR') > -1
          );
          return isLogo ? doc?.url : doc || null;
        }
        return null;
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes.lenders && changes.lenders.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
